import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private stormSource = new BehaviorSubject<boolean>(false);
  currentStorm = this.stormSource.asObservable();
  changeStorm = (state: boolean) => { this.stormSource.next(state); }

  private hydroStormSource = new BehaviorSubject<boolean>(false);
  currentHydroStorm = this.hydroStormSource.asObservable();
  changeHydroStorm = (state: boolean) => { this.hydroStormSource.next(state); }

  private footerHeightSource = new BehaviorSubject<number>(0);
  currentFooterHeight = this.footerHeightSource.asObservable();
  changeFooterHeight = (height: number) => { this.footerHeightSource.next(height); }

  private currentUrlSource = new BehaviorSubject<string>('');
  currentUrl = this.currentUrlSource.asObservable();
  changeCurrentUrl = (url: string) => { this.currentUrlSource.next(url); }

  private factWidgetSource = new BehaviorSubject<boolean>(true);
  currentFactWidget = this.factWidgetSource.asObservable();
  changeFactWidget = (state: boolean) => { this.factWidgetSource.next(state); }

  private levelWidgetSource = new BehaviorSubject<boolean>(true);
  currentLevelWidget = this.levelWidgetSource.asObservable();
  changeLevelWidget = (state: boolean) => { this.levelWidgetSource.next(state); }

  private hydroStormWidgetSource = new BehaviorSubject<boolean>(true);
  currentHydroStormWidget = this.hydroStormWidgetSource.asObservable();
  changeHydroStormWidget = (state: boolean) => { this.hydroStormWidgetSource.next(state); }

  defaultCity = { id: 26851, lat: 53.93, lng: 27.64, name: "Минск-Независимости", country: 'BY', timezone: 3, icao: null};
  private citySource = new BehaviorSubject<object>(isPlatformBrowser(this.platformId) ? (()=>{return JSON.parse(localStorage.getItem('_city')) || this.defaultCity })() : this.defaultCity);
  currentCity = this.citySource.asObservable();
  changeCity = (city: object) => { 
    this.citySource.next(city);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('_city', JSON.stringify(city));
    }
  }

  defaultTime = false;
  private timeSource = new BehaviorSubject<boolean>(isPlatformBrowser(this.platformId) ? (() => {
    return (typeof JSON.parse(sessionStorage.getItem('_timeUTC')) === "boolean") ? JSON.parse(sessionStorage.getItem('_timeUTC')) : this.defaultTime
  })() : this.defaultTime);
  currentTime = this.timeSource.asObservable();
  changeTime = (time: boolean) => {
    this.timeSource.next(time);
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('_timeUTC', JSON.stringify(time));
    }
  }

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {  }

}
